<template>
  <div class='core'>
    <div class='layui-fluid'>
      <pub-search
        :search-type="'add'"
        :tableObj='tableObj'
        :searchConfig='searchConfig'
        exportType="1"
      >
      </pub-search>
      <layui-table
        ref='systemConfigRef'
        table-name='yw_repair_approve_config_v'
        :page-size='20'
        :page-range='6'
        :page-options='[10, 20, 50, 100]'
        :skin="'line'"
      >
        <div>
          <div field="BRAND_NAME"  title="品牌名称"></div>
          <div field="IS_STORE_MANAGER_APPROCE"  title="是否店长审核">
            <script type="text/html" id="switchTpl" v-pre>
              <input type="checkbox" name="B_ENABLED" value="{{d.B_ENABLED}}" data-id="{{ d.ID }}" lay-skin="switch"
                     lay-text="开启|关闭" lay-filter="switchFilter" {{ d.IS_STORE_MANAGER_APPROCE == '1' ? 'checked' : '' }}>
            </script>
          </div>
        </div>
      </layui-table>

    </div>
  </div>
</template>
<script>
import "../../../utils/map/css/core.css"

export default {
  name: 'storeManagerManage',
  data () {
    return {
      tableObj: {
        checkedRows: 0,
        queryObject: {}
      },
      searchConfig: {
        basic: [
          {
            TYPE: 'input',
            WIDTH: 260,
            FIELD: 'BRAND_NAME:2',
            PLACEHOLDER: '请输入品牌条件'
          }
        ],
        showBatch: false
      },
    }
  },
  mounted(){
    this.tableObj = this.$refs.systemConfigRef;

    this.layui.form.on('switch(switchFilter)', (obj) => {
      let title = obj.elem.checked ? '开启' : '关闭';
      this.layer.openConfirm('确定要' + title + "吗？", ()=> {
        let row = obj.elem.dataset;
        let id = row.id;
        let editRow  = {};
        if(id) {
          editRow.ID = id;
          editRow.IS_NEW = false;
        } else {
          editRow.BRAND_ID = row.BRAND_ID;
          editRow.BRAND_NAME = row.BRAND_NAME;
        }
        editRow.IS_STORE_MANAGER_APPROCE = obj.elem.checked ? '1' : '0';
        this.api.save('YW_REPAIR_APPROVE_CONFIG', editRow,  'YW_REPAIR_APPROVE_CONFIG_REQUEST').then(response => {
          if(response.errorMsg) {
            this.layer.openAlert(response.errorMsg, false);
          } else {
            this.layer.openSuccess(title + '成功!');
            this.tableObj.pageInfo.pageIndex = 1;
            this.tableObj.load();
          }
        });
      }, () => {this.tableObj.load();});
    });
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/components/ywpt/systemconfig/BrandApproveConfig.vue